export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  imageUrl: string;
  imageWidth: number;
  imageHeight: number;
  imageSeq: string;
  imageQuery: string;
  productCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '家居好物',
    slug: '家居好物',
    description: '甄选全球家居精品，从家具到装饰，为您的家注入品质与温度。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20modern%20living%20room%20interior%20with%20wooden%20furniture%2C%20soft%20textiles%2C%20indoor%20plants%2C%20and%20natural%20light%20streaming%20through%20large%20windows%2C%20Scandinavian%20design%20aesthetic%2C%20cozy%20atmosphere&width=600&height=400&seq=category-home&orientation=landscape',
    imageWidth: 600,
    imageHeight: 400,
    imageSeq: 'category-home',
    imageQuery: 'A warm and inviting modern living room interior with wooden furniture, soft textiles, indoor plants, and natural light streaming through large windows, Scandinavian design aesthetic, cozy atmosphere',
    productCount: 4,
  },
  {
    id: 'cat-2',
    name: '时尚精品',
    slug: '时尚精品',
    description: '汇聚全球设计师品牌与匠心工艺，让每一件单品都成为您的风格宣言。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylish%20fashion%20display%20with%20designer%20accessories%20on%20a%20marble%20surface%2C%20leather%20handbag%2C%20silk%20scarf%2C%20and%20silver%20jewelry%2C%20elegant%20editorial%20style%20photography%20with%20warm%20neutral%20tones&width=600&height=400&seq=category-fashion&orientation=landscape',
    imageWidth: 600,
    imageHeight: 400,
    imageSeq: 'category-fashion',
    imageQuery: 'A stylish fashion display with designer accessories on a marble surface, leather handbag, silk scarf, and silver jewelry, elegant editorial style photography with warm neutral tones',
    productCount: 3,
  },
  {
    id: 'cat-3',
    name: '生活优选',
    slug: '生活优选',
    description: '发现让日常更美好的小物，从健康到休闲，精致生活触手可及。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20serene%20lifestyle%20flatlay%20with%20yoga%20accessories%2C%20organic%20cotton%20clothing%2C%20a%20book%2C%20and%20a%20cup%20of%20tea%20on%20a%20wooden%20floor%2C%20morning%20sunlight%2C%20mindful%20living%20aesthetic&width=600&height=400&seq=category-lifestyle&orientation=landscape',
    imageWidth: 600,
    imageHeight: 400,
    imageSeq: 'category-lifestyle',
    imageQuery: 'A serene lifestyle flatlay with yoga accessories, organic cotton clothing, a book, and a cup of tea on a wooden floor, morning sunlight, mindful living aesthetic',
    productCount: 3,
  },
  {
    id: 'cat-4',
    name: '特惠专区',
    slug: '特惠专区',
    description: '精选好物限时特惠，品质不打折，让您以更优价格享受精品生活。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20beautifully%20arranged%20collection%20of%20premium%20lifestyle%20products%20with%20sale%20tags%2C%20gift%20boxes%2C%20elegant%20home%20accessories%2C%20and%20beauty%20items%20on%20a%20minimalist%20white%20background%2C%20luxury%20shopping%20aesthetic&width=600&height=400&seq=category-sale&orientation=landscape',
    imageWidth: 600,
    imageHeight: 400,
    imageSeq: 'category-sale',
    imageQuery: 'A beautifully arranged collection of premium lifestyle products with sale tags, gift boxes, elegant home accessories, and beauty items on a minimalist white background, luxury shopping aesthetic',
    productCount: 2,
  },
];